import { Address, Country } from '@/api/types/public';

export const getDefaultAddress = (_addressList: Address[]) => {
  if (!_addressList || _addressList.length === 0) {
    return null;
  }
  const defaultAddress = _addressList.find((item) => item.default === 1);
  if (defaultAddress) {
    return defaultAddress;
  } else {
    return _addressList[0];
  }
};

// 处理国家不同的情况. billing地址进行编辑时，如果国家跟shipping国家不一致，需要做一下处理
export const handleDiffCountry = (
  billingAddress: Address,
  shippingAddress: Address,
  countryList: Country[],
): Address => {
  const toEditAddress = {
    ...billingAddress,
  };
  if (shippingAddress.country_id !== billingAddress.country_id) {
    const _country = countryList.find((item) => item.country_id === shippingAddress.country_id);
    if (_country) {
      toEditAddress.country = _country.country;
      toEditAddress.country_id = shippingAddress.country_id;
      toEditAddress.cpf = '';
      toEditAddress.province_id = '';
      toEditAddress.province = '';
      toEditAddress.region_code = '';
    }
  }
  return toEditAddress;
};
